<div class="card card-body mt-3" [formGroup]="notaForm">
	<div class="form-group">
		<label class="font-weight-bold">Tipo</label>
		<!-- Opciones para Nota de Crédito (61) -->
		<div *ngIf="codigoTipoDte === 61">
			<div class="form-check form-check-inline">
				<input class="form-check-input" type="radio" id="anulacion" name="tipoNota" [checked]="selectedTipoNota === 'Anulación'" (change)="onChangeTipoNota('Anulación')" />
				<label class="form-check-label" for="anulacion">Anulación</label>
			</div>
			<div class="form-check form-check-inline">
				<input class="form-check-input" type="radio" id="correccionMonto" name="tipoNota" [checked]="selectedTipoNota === 'Corrección Monto'" (change)="onChangeTipoNota('Corrección Monto')" />
				<label class="form-check-label" for="correccionMonto">Corrección Monto</label>
			</div>
			<div class="form-check form-check-inline">
				<input class="form-check-input" type="radio" id="correccionTexto" name="tipoNota" [checked]="selectedTipoNota === 'Corrección Texto'" (change)="onChangeTipoNota('Corrección Texto')" />
				<label class="form-check-label" for="correccionTexto">Corrección Texto</label>
			</div>
		</div>
		<div *ngIf="codigoTipoDte === 56">
			<div class="form-check form-check-inline">
				<input class="form-check-input" type="radio" id="intereses" name="tipoNota" [checked]="selectedTipoNota === 'Intereses'" (change)="onChangeTipoNota('Intereses')" />
				<label class="form-check-label" for="intereses">Intereses</label>
			</div>
			<div class="form-check form-check-inline">
				<input class="form-check-input" type="radio" id="anulacion" name="tipoNota" [checked]="selectedTipoNota === 'Anulación'" (change)="onChangeTipoNota('Anulación')" />
				<label class="form-check-label" for="anulacion">Anulación</label>
			</div>
		</div>
		<hr />
		<!-- Corrección Texto -->
		<div class="form-group" *ngIf="selectedTipoNota === 'Corrección Texto'">
			<h6 class="mb-3">Descripcion de Correción</h6>
			<div class="row mb-3">
				<label class="col-1 col-form-label label__Correcion">Corrección:</label>
				<div class="col-10">
					<input
						name="itemsCorreccion"
						id="itemsCorreccion"
						formControlName="itemsCorreccion"
						class="form-control"
						style="resize: none"
						[ngClass]="{
							'is-invalid': notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)
						}"
					/>
					<small class="form-text text-muted">Si escribe texto, se entenderá que está modificando items. Un ejemplo puede ser: DONDE DICE "XXX" DEBE DECIR "YYY"</small>
				</div>
			</div>
			<hr />
		</div>
		<!-- Motivo -->
		<div class="row mb-3">
			<p class="col-12 text-muted"><i>Nota: Datos de uso interno, no se reflejan en el documento.</i></p>
			<label class="col-1 col-form-label label__Motivo">Motivo:</label>
			<div class="col-3">
				<ng-container *ngIf="!isSingleMotivo; else singleMotivo">
					<ng-select
						[items]="motivosParaMostrar"
						bindLabel="label"
						bindValue="value"
						placeholder="Seleccione Motivo"
						formControlName="motivo"
						[clearable]="false"
						(change)="onChangeMotivo($event)"
						[ngClass]="{
							'is-invalid': notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)
						}"
					>
					</ng-select>
					<div *ngIf="notaForm.get('motivo').invalid && (notaForm.get('motivo').touched || notaForm.get('motivo').dirty)" class="invalid-feedback d-block">
						<div *ngIf="notaForm.get('motivo').errors?.required">Campo requerido</div>
					</div>
				</ng-container>
				<ng-template #singleMotivo>
					<input type="text" class="form-control" [value]="motivosParaMostrar[0]" disabled />
				</ng-template>
			</div>
		</div>
	</div>
</div>
